import type { ExpenseBootstrapEntity } from "../../domain/entities/ExpenseBootstrapEntity";

let bootstrapData: ExpenseBootstrapEntity | null = null;
let bootstrapPromise: Promise<ExpenseBootstrapEntity> | null = null;
let bootstrapError: string | null = null;

export function setExpenseBootstrapData(data: ExpenseBootstrapEntity | null): void {
  bootstrapData = data;
}

export function getExpenseBootstrapData(): ExpenseBootstrapEntity | null {
  return bootstrapData;
}

export function setExpenseBootstrapPromise(
  promise: Promise<ExpenseBootstrapEntity> | null,
): void {
  bootstrapPromise = promise;
}

export function getExpenseBootstrapPromise(): Promise<ExpenseBootstrapEntity> | null {
  return bootstrapPromise;
}

export function setExpenseBootstrapError(error: string | null): void {
  bootstrapError = error;
}

export function getExpenseBootstrapError(): string | null {
  return bootstrapError;
}

export function clearExpenseBootstrapStore(): void {
  bootstrapData = null;
  bootstrapPromise = null;
  bootstrapError = null;
}
